import AbstractEventStatusModel from './AbstractEventStatusModel';
import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';

@doc.urnResource('event_status')
@model.cacheDuration()
export default class EventStatusModel extends AbstractEventStatusModel {
	public get color() {
		switch (this.reference) {
			case 'ENABLED':
				return 'green';
			case 'DISABLED':
				return 'red';
		}
	}
}
